import { memo, useMemo, type FC } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id/index.ts';

import { HoverableWarningIcon } from './HoverableWarningIcon.tsx';
import { Number, Wrapper } from './styled.ts';

interface ItemProps {
  id: string;
  index: number;
  title: string;
  active: boolean;
  error: boolean | undefined;
  setActiveId: (id: string) => void;
  dataTestId: string | undefined;
}

export const Item: FC<ItemProps> = memo(function Item({ id, index, title, active, error, setActiveId, dataTestId }) {
  const testId = useMemo(() => getDataTestId(dataTestId, active ? 'active' : 'inactive'), [active, dataTestId]);

  const handleClick = useCallbackRef(() => {
    setActiveId(id);
  });

  return (
    <Wrapper $active={active} $error={error ?? false} onClick={handleClick} data-testid={testId}>
      <Number $active={active}>{index + 1}</Number>
      {title}
      {error && <HoverableWarningIcon />}
    </Wrapper>
  );
});
